// NOTE: key 'CLIENT_LIST' is used by many useSelector hooks throughout the app

import registerClientRedux from 'app/resources/client';
import { useSelector } from 'react-redux';

const key = 'CLIENT_LIST';

export const clientListRedux = registerClientRedux(key, ['LIST']);

export const useClientList = () => useSelector((state) => state[key]);
